import { NgModule } from '@angular/core';
import { APOLLO_OPTIONS } from 'apollo-angular';
import { NotifyService } from '@services/notify.service';
import { IError, IErrorDetail } from '@interfaces/nebula';
import { RemoveTypenameFromVariablesLink } from '@apollo/client/link/remove-typename';
import UploadHttpLink from 'apollo-upload-client/UploadHttpLink.mjs';
import { ErrorLink } from '@apollo/client/link/error';
import { CombinedGraphQLErrors, CombinedProtocolErrors } from '@apollo/client/errors';
import { ApolloClient, ApolloLink, InMemoryCache } from '@apollo/client';

const getBaseUrl = () => document.getElementsByTagName('base')[0].href;

// Log any GraphQL errors, protocol errors, or network error that occurred
const errorLink = new ErrorLink(({ error }) => {
  let err: IError = {
    error: [],
    message: '',
    name: '',
    ok: false,
    status: 500,
    statusText: '',
    url: ''
  };

  if (CombinedGraphQLErrors.is(error) || CombinedProtocolErrors.is(error)) {
    error.errors.forEach(({ message, extensions }) => {
      if (extensions?.code === 'UNAUTHORIZED_ACCESS' || extensions?.code === 'authorization') {
        err = null;
      } else {
        (err.error as IErrorDetail[]).push({
          code: 'GraphQL error',
          description: message,
          errors: undefined,
          status: 500,
          title: '',
          traceId: '',
          type: ''
        });
      }
    });
  } else {
    // Network Error
    (err.error as IErrorDetail[]).push({
      code: 'Network error',
      description: error.message,
      errors: undefined,
      status: 500,
      title: '',
      traceId: '',
      type: ''
    });
  }

  if (err) {
    NotifyService.serverGlobalError(err);
  }
});

const uploadLink = new UploadHttpLink({
  uri: getBaseUrl() + 'api/graphql',
  credentials: 'include'
});

const removeTypenameLink = new RemoveTypenameFromVariablesLink();
const httpLinkWithErrorHandling = ApolloLink.from([errorLink, removeTypenameLink, uploadLink as unknown as ApolloLink]);

const client = new ApolloClient({
  link: httpLinkWithErrorHandling,
  cache: new InMemoryCache(),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'all'
    },
    query: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'all'
    },
    mutate: {
      errorPolicy: 'all'
    }
  }
});

@NgModule({
  providers: [
    {
      provide: APOLLO_OPTIONS,
      useValue: client,
      deps: []
    }
  ]
})
export class GraphQLModule {}
